export const getIntegrationAgencies = ({ token, query }) => ({
  HTTPMethod: "get",
  path: "/api/v1/conduit/integrations/agencies",
  queryParams: query,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
